/** Session cookie name — must match services/api auth-cookie.ts */
export const MEMBER_SESSION_COOKIE = 'loamify_token';

/** Exact paths that require a signed-in member session (web-public). */
export const MEMBER_ONLY_EXACT_PATHS = new Set([
  '/create',
  '/write-article',
  '/edit-profile',
  '/onboarding',
  '/learning',
  '/drafts',
  '/bookmarks',
  '/notifications',
  '/insights',
]);

/** Prefixes that require a signed-in member session (web-public). */
export const MEMBER_ONLY_ROUTE_PREFIXES = ['/settings', '/messages'] as const;

export function isMemberOnlyPath(pathname: string): boolean {
  const path = pathname.split('?')[0]?.split('#')[0] ?? pathname;
  if (MEMBER_ONLY_EXACT_PATHS.has(path)) return true;
  if (path.startsWith('/settings') || path.startsWith('/messages')) return true;
  if (/^\/posts\/[^/]+\/edit\/?$/.test(path)) return true;
  return false;
}

/**
 * Decoy paths probed by scanners — touching these triggers IP block + admin alert.
 * Keep lowercase; middleware normalizes pathname before matching.
 */
export const HONEYPOT_PATHS = new Set([
  '/wp-admin',
  '/wp-login.php',
  '/.env',
  '/.git/config',
  '/phpmyadmin',
  '/administrator',
  '/xmlrpc.php',
  '/api/internal/debug',
  '/api/v1/internal',
  '/actuator/env',
  '/server-status',
  '/.aws/credentials',
  '/config.json',
  '/debug/default/view',
]);

export const HONEYPOT_PREFIXES = ['/wp-includes/', '/wp-content/', '/.well-known/acme-challenge/../'] as const;

export function isHoneypotPath(pathname: string): boolean {
  const path = pathname.toLowerCase();
  if (HONEYPOT_PATHS.has(path)) return true;
  return HONEYPOT_PREFIXES.some((prefix) => path.startsWith(prefix));
}
